import {
    resolveTaskTypeFromOption,
    TASK_TYPE_OPTION_GROUPS,
} from "@components/settings/OrganizationCloseTemplates/closeTemplateTasksDrawer.constants";
import { WORKSPACE_WORKFLOW_TASK_TYPES } from "@common/constants/taskTypeDefinitions";
import { TaskType } from "@common/types/task";

type WorkflowGroup = (typeof TASK_TYPE_OPTION_GROUPS)[number];

const isWorkspaceWorkflowOption = (option: WorkflowGroup["options"][number]) =>
    WORKSPACE_WORKFLOW_TASK_TYPES.some((type) => type === option.value);

interface BuildWorkspaceWorkflowGroupsParams {
    groups?: readonly WorkflowGroup[];
    isTaskTypeAllowed?: (type: TaskType) => boolean;
}

export const buildWorkspaceWorkflowGroups = ({
    groups = TASK_TYPE_OPTION_GROUPS,
    isTaskTypeAllowed = () => true,
}: BuildWorkspaceWorkflowGroupsParams = {}): WorkflowGroup[] =>
    groups
        .map((group) => ({
            ...group,
            options: group.options.filter(
                (option) =>
                    isWorkspaceWorkflowOption(option) &&
                    isTaskTypeAllowed(resolveTaskTypeFromOption(option.value)),
            ),
        }))
        .filter((group) => group.options.length > 0)
        .map((group) =>
            group.options.length === 1 ? { ...group, label: null } : group,
        );
